import React from 'react';
import { IconDefinition } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, IconButton } from '@mui/material';
import { GridToolbarContainer, selectedGridRowsCountSelector, useGridApiContext, useGridSelector } from '@mui/x-data-grid-pro';
import { useFeatureToggles } from '../../feature-toggles';
import { Tooltip } from '../tooltip/tooltip';

export interface IFasitDataGridContextToolbarButton {
  title: string;
  icon: IconDefinition;
  onClick: () => void;
  // A button is only disabled together with the reason, so the user is never left guessing.
  disabledReason?: string;
}

export interface IFasitDataGridContextToolbarProps {
  buttons?: IFasitDataGridContextToolbarButton[];
  textButtons?: React.ReactNode[];
}

// A disabled button gets no mouse events, so its tooltip hangs on a wrapper and the name stays on the button.
function renderButton(button: IFasitDataGridContextToolbarButton) {
  const iconButton = (
    <IconButton onClick={button.onClick} disabled={!!button.disabledReason} aria-label={button.title} sx={{ fontSize: 20 }}>
      <FontAwesomeIcon icon={button.icon} />
    </IconButton>
  );

  if (button.disabledReason) {
    return (
      <Tooltip key={button.title} title={`${button.title} – ${button.disabledReason}`}>
        <span>{iconButton}</span>
      </Tooltip>
    );
  }

  return (
    <Tooltip key={button.title} title={button.title}>
      {iconButton}
    </Tooltip>
  );
}

export function FasitDataGridContextToolbar(props: IFasitDataGridContextToolbarProps) {
  const { buttons, textButtons } = props;
  const apiRef = useGridApiContext();
  const selectedRowsCount = useGridSelector(apiRef, selectedGridRowsCountSelector);
  const { isFeatureEnabled } = useFeatureToggles();
  const showSelectedRowsCount = isFeatureEnabled('EnableDataGridSelectedRowsCount') && selectedRowsCount > 0;

  return (
    <GridToolbarContainer className="contextGridToolbar" sx={{ minHeight: 45 }}>
      {showSelectedRowsCount && (
        <Box component="span" className="FasitDataGridToolbar-title" sx={{ color: 'secondary.main', marginLeft: '11px' }}>
          {selectedRowsCount} valgt
        </Box>
      )}
      {buttons && buttons.map(renderButton)}
      {textButtons && textButtons.map(button => button)}
    </GridToolbarContainer>
  );
}
